import { getSeguro, putSeguro } from '../../shared/helper/requests';
import { removerCachePedidosUsuario } from '../requerimentos/consultar/actions';

export function listarSucesso(dados) {    
    return {
        type: 'CONSULTAR_NOTIFICACOES',
        payload: {
            notificacoes: dados,
            qtdNaoLida: contarNaoLidas(dados)
        }
    }
}


export function quantidadeNotificacaoNaoLidaSucesso(qtd) {   
    localStorage.setItem('notificacoesNaoLidas', qtd);

    if (qtd > 0) {
        removerCachePedidosUsuario();   
    }

    return {
        type: 'CONSULTAR_QUANTIDADE_NOTIFICACOES_NAO_LIDA',
        payload: { qtdNaoLida: qtd }
    }
}

export const listarErro = (error) => {
    return { type: 'ERRO_CONSULTAR_NOTIFICACOES' }
}

const contarNaoLidas = (dados) => {
    let qtdNaoLida = 0;
    if (dados && dados.length > 0) {
        qtdNaoLida = dados.map(dado => {
            return dado.listaNotificacao.filter(item => item.geral === false && item.lida === false).length
        }).reduce((acumulador, current) => acumulador + current, 0);
    }

    return qtdNaoLida;
}


export const consultarNotificacoes = () => dispatch => {
    dispatch({ type: 'CARREGANDO_NOTIFICACOES' });
    return getSeguro(dispatch, `notificacoesServices/notificacoes/`, listarSucesso, listarErro);
}

export const consultarQuantasNotificacoesNaoLidas = () => dispatch => {
    dispatch({ type: 'CARREGANDO_NOTIFICACOES' });
    return getSeguro(dispatch, `notificacoesServices/notificacoes/naoLidas/count`, quantidadeNotificacaoNaoLidaSucesso, listarErro);
}

const detalharNotificacaoSucesso = (dados) => dispatch => {
    dispatch({ type: 'OPERACAO_REALIZADA_COM_SUCESSO' })
}

const detalharNotificacaoFalha = (error) => dispatch => {  
    dispatch({ type: 'OPERACAO_REALIZADA_COM_ERRO' })
}

export const detalharNotificacao = (notificacao, qtdNaoLida) => dispatch => {
    dispatch({ type: 'DETALHAR_NOTIFICACAO', payload: { notificacaoSelecionada: notificacao, qtdNaoLida: qtdNaoLida } });
    //so chama a confirmação de leitura se a notificação for de sistema, se for geral não precisa
    return (!notificacao.geral ? putSeguro(dispatch, `notificacoesServices/notificacoes/confirmarLeitura/${notificacao.idNotificacao}`, {}, detalharNotificacaoSucesso, detalharNotificacaoFalha) : '');
}
